import { Platform } from "react-native";

const getSocketUrl = () => {
  // 1. WEB ENVIRONMENT HANDLING
  if (Platform.OS === "web" && typeof window !== "undefined") {
    const { hostname, protocol } = window.location;

    // Local Web Development
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      const wsProtocol = protocol === "https:" ? "wss:" : "ws:";
      return `${wsProtocol}//localhost:8082`;
    }

    // Production / Staging Web (Uses current page domain & protocol)
    const wsProtocol = protocol === "https:" ? "wss:" : "ws:";
    return `${wsProtocol}//${hostname}/socket/`;
  }

  // 2. NATIVE MOBILE ENVIRONMENT (iOS & Android)
  return "wss://getmeeza.com/socket/";
};

export const SOCKET_URL = getSocketUrl();

// import { Platform } from "react-native";

// const getSocketUrl = () => {
//   if (Platform.OS === "web" && typeof window !== "undefined") {
//     const hostname = window.location.hostname;

//     if (hostname === "localhost" || hostname === "127.0.0.1") {
//       return "ws://localhost:8082";
//     }
//   }

//   // return "wss://getmeeza.com";
//   return "wss://getmeeza.com/socket/";
// };

// export const SOCKET_URL = getSocketUrl();
